import React from 'react';
import divaimg from '../assets/images/diva.png';
import userGuideimg from '../assets/images/userGuide.png'
import releaseNotesimg from '../assets/images/releaseNotes.png'
import { useNavigate } from 'react-router-dom';

const Navbar = ({subModule}) => {
    const navigate = useNavigate();
    const handleClick = () => {
        // Navigate to a new route
        navigate('/userguide'); // Replace with the route you want
      };
    const handleReleaseClick = () => {
        // Navigate to a new route
        navigate('/releaseNote'); // Replace with the route you want
      };

  return (
<div className='clientHeader' id="clientHeader">
      <div className='contractimg '>
      <img src={divaimg} alt="diva" className="diva-img" /> |
      
      </div>
      <p className="displayHeaderText">Delivery Management Insights Virtual Assistant {subModule && <span> | {subModule} </span>}</p>
      <img src={userGuideimg} alt="User Guide" id="diva-userguide" className="diva-userguide" onClick={() => handleClick('../assets/data/DIVAUserGuide.pdf')}
        title="User Guide" />
      <img src={releaseNotesimg} title="Release Notes" alt="Release Notes" onClick={() => handleReleaseClick('../assets/data/DIVAUserGuide.pdf')} className="diva-releasenotes" />
      </div>
  );
};

export default Navbar;
